import { useCallback, useEffect, useState } from 'react';

export enum MediaDefaults {
  XS = 320,
  SM = 540,
  MD = 768,
  LG = 1084,
  XL = 1400,
  XXL = 1600,
  XXXL = 1920,
}

export const useMediaLessThanSize = (sizeThreshold: MediaDefaults | number): boolean => {
  const [isLessThanSize, setIsLessThanSize] = useState<boolean>(false);

  const handleEvent = useCallback((e: MediaQueryListEvent) => {
    setIsLessThanSize(e.matches);
  }, []);

  useEffect(() => {
    setIsLessThanSize(window.matchMedia(`(max-width: ${sizeThreshold}px)`).matches);
    const mainDiv = document.getElementById('MemSellerExperienceMainContent');
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width <= sizeThreshold) {
          setIsLessThanSize(true);
        } else {
          setIsLessThanSize(false);
        }
      });
    });
    if (mainDiv) {
      resizeObserver.observe(mainDiv);
    }

    return () => {
      if (mainDiv) {
        resizeObserver.unobserve(mainDiv);
      }
      resizeObserver.disconnect();
    };
  }, [handleEvent, sizeThreshold]);

  return isLessThanSize;
};

export const useMediaMoreThanSize = (sizeThreshold: number): boolean => {
  const [isLessThanSize, setIsLessThanSize] = useState<boolean>(false);

  const handleEvent = useCallback((e: MediaQueryListEvent) => {
    setIsLessThanSize(e.matches);
  }, []);

  useEffect(() => {
    setIsLessThanSize(window.matchMedia(`(max-width: ${sizeThreshold}px)`).matches);
    const mainDiv = document.getElementById('MemSellerExperienceMainContent');
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width <= sizeThreshold) {
          setIsLessThanSize(false);
        } else {
          setIsLessThanSize(true);
        }
      });
    });
    if (mainDiv) {
      resizeObserver.observe(mainDiv);
    }

    return () => {
      if (mainDiv) {
        resizeObserver.unobserve(mainDiv);
      }
      resizeObserver.disconnect();
    };
  }, [handleEvent, sizeThreshold]);

  return isLessThanSize;
};
